import { Component, Input } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { ServiceEntrySheetState } from 'src/app/proxy/service-entry-sheets';

@Component({
  selector: 'app-service-entry-sheet-state-tag',
  templateUrl: './service-entry-sheet-state-tag.component.html',
  standalone: false,
})
export class ServiceEntrySheetStateTagComponent extends AppBaseComponent {
  @Input({ required: true }) state: ServiceEntrySheetState;

  getStateLabel(): string {
    switch (this.state) {
      case ServiceEntrySheetState.Generated:
        return this.l('::Generated');
      case ServiceEntrySheetState.Pending:
        return this.l('::Pending');
      case ServiceEntrySheetState.Reversed:
        return this.l('::Reversed');
      default:
        return this.l('::Unknown');
    }
  }

  getStateClass(): string {
    switch (this.state) {
      case ServiceEntrySheetState.Generated:
        return 'generated-tag';
      case ServiceEntrySheetState.Pending:
        return 'pending-tag';
      case ServiceEntrySheetState.Reversed:
        return 'reversed-tag';
      default:
        return 'unknown-tag';
    }
  }
}
